import { Box, Flex, Input, Text } from "@chakra-ui/react"
import { LuSend } from "react-icons/lu"
import { BORDER_COLOR, META_COLOR, NAVY, SUBTLE_BG } from "./constants"

const PLACEHOLDER_DEFAULT = "Ask about registration, travel, CME..."
const PLACEHOLDER_AGENDA_READY = "Ask about registration, agenda sessions..."

export default function ChatInput({
    input,
    onInputChange,
    onSubmit,
    isLoading,
    disabled,
    agendaReady = false,
    placeholder,
    // The schedule finder reuses the field without the chat trimmings.
    divider = true,
    disclaimer = true,
    bg = "#fff",
}) {
    const placeholderText = placeholder ?? (agendaReady ? PLACEHOLDER_AGENDA_READY : PLACEHOLDER_DEFAULT)

    const isDisabled = disabled || isLoading

    const handleKeyDown = e => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault()
            onSubmit(e)
        }
    }

    return (
        <Box bg={bg} borderTop={divider ? "1px solid" : "none"} borderColor={BORDER_COLOR} flexShrink={0}>
            <Flex as="form" onSubmit={onSubmit} align="center" gap="12px" px="16px" pt="12px" pb="6px">
                <Flex
                    align="center"
                    flex={1}
                    bg={SUBTLE_BG}
                    borderRadius="full"
                    h="44px"
                    px="16px"
                    border="1px solid"
                    borderColor={BORDER_COLOR}
                >
                    <Input
                        value={input}
                        onChange={onInputChange}
                        onKeyDown={handleKeyDown}
                        placeholder={placeholderText}
                        fontSize="16px"
                        color="#1E293B"
                        _placeholder={{ color: META_COLOR }}
                        border="none"
                        outline="none"
                        bg="transparent"
                        h="100%"
                        p={0}
                        _focus={{ boxShadow: "none" }}
                        disabled={isDisabled}
                    />
                </Flex>
                <Flex
                    as="button"
                    type="submit"
                    align="center"
                    justify="center"
                    w="44px"
                    h="44px"
                    borderRadius="full"
                    bg={NAVY}
                    flexShrink={0}
                    cursor={isDisabled ? "default" : "pointer"}
                    opacity={isDisabled ? 0.5 : 1}
                    _hover={{ opacity: isDisabled ? 0.5 : 0.88 }}
                    disabled={isDisabled}
                >
                    <LuSend color="#fff" size={18} />
                </Flex>
            </Flex>
            {disclaimer && (
                <Text color="#999" fontSize="xs" textAlign="center" mt={0} mb={2}>
                    AI can make mistakes. Check important information.
                </Text>
            )}
        </Box>
    )
}
